// extracted by mini-css-extract-plugin
module.exports = {"card":"_1s1R_"};